module.exports = __webpack_public_path__ + "static/media/logoAssistencia.e94d42b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logoAssistencia.png
// module id = 613
// module chunks = 0